export default class DaumSchoolConfirmService {
  constructor(http) {
    this.http = http;
  }

  async findAllConfirms(conditions = {}) {
    const queryParams = Object.entries(conditions)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
    return this.http.fetch(`/api/daumschoolconfirm/readall?${queryParams}`, {
      method: "GET",
    });
  }

  async createOrUpdateConfirm(data) {
    // 서버 API 준비되면 연결
    // endpoint: /api/daumschoolconfirm/createorupdate
    return this.http.fetch(`/api/daumschoolconfirm/createorupdate`, {
      method: "POST",
      body: JSON.stringify(data),
    });
  }
}
